module.exports = __webpack_public_path__ + "static/media/p4.1f7882ce.jpeg";